import "antd/es/date-picker/style";
import _DatePicker from "antd/es/date-picker";
import "antd/es/time-picker/style";
import _TimePicker from "antd/es/time-picker";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useContext } from 'react';
import moment from 'moment';
import { FieldLabel, parseValueToMoment } from '@ant-design/pro-utils';
/**
 * 日期选择组件
 *
 * @param
 */

var FieldTimePicker = function FieldTimePicker(_ref, ref) {
  var text = _ref.text,
      mode = _ref.mode,
      light = _ref.light,
      label = _ref.label,
      format = _ref.format,
      render = _ref.render,
      renderFormItem = _ref.renderFormItem,
      plain = _ref.plain,
      fieldProps = _ref.fieldProps;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var size = useContext(_ConfigProvider.SizeContext);

  var _useContext = useContext(_ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('pro-field-date-picker');
  var finalFormat = (fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.format) || format || 'HH:mm:ss';
  var isNumberOrMoment = moment.isMoment(text) || typeof text === 'number';

  if (mode === 'read') {
    var dom = /*#__PURE__*/React.createElement("span", {
      ref: ref
    }, text ? moment(text, isNumberOrMoment ? undefined : finalFormat).format(finalFormat) : '-');

    if (render) {
      return render(text, _objectSpread({
        mode: mode
      }, fieldProps), /*#__PURE__*/React.createElement("span", null, dom));
    }

    return dom;
  }

  if (mode === 'edit' || mode === 'update') {
    var _dom;

    var disabled = fieldProps.disabled,
        _onChange = fieldProps.onChange,
        placeholder = fieldProps.placeholder,
        allowClear = fieldProps.allowClear,
        value = fieldProps.value;
    var momentValue = parseValueToMoment(value, finalFormat);

    if (light) {
      var valueStr = momentValue && momentValue.format(finalFormat) || '';
      _dom = /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-light"),
        onClick: function onClick() {
          setOpen(true);
        }
      }, /*#__PURE__*/React.createElement(_TimePicker, _extends({
        value: momentValue,
        format: format,
        ref: ref
      }, fieldProps, {
        onChange: function onChange(v) {
          _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
          setTimeout(function () {
            setOpen(false);
          }, 0);
        },
        onOpenChange: setOpen,
        open: open
      })), /*#__PURE__*/React.createElement(FieldLabel, {
        label: label,
        disabled: disabled,
        placeholder: placeholder,
        size: size,
        value: valueStr,
        allowClear: allowClear,
        onClear: function onClear() {
          _onChange === null || _onChange === void 0 ? void 0 : _onChange(null);
        },
        expanded: open
      }));
    } else {
      _dom = /*#__PURE__*/React.createElement(_DatePicker.TimePicker, _extends({
        ref: ref,
        format: format,
        bordered: plain === undefined ? true : !plain
      }, fieldProps, {
        value: momentValue
      }));
    }

    if (renderFormItem) {
      return renderFormItem(text, _objectSpread({
        mode: mode
      }, fieldProps), _dom);
    }

    return _dom;
  }

  return null;
};
/**
 * 时间区间选择
 *
 * @param param0
 * @param ref
 */


var FieldTimeRangePicker = function FieldTimeRangePicker(_ref2) {
  var text = _ref2.text,
      mode = _ref2.mode,
      format = _ref2.format,
      render = _ref2.render,
      renderFormItem = _ref2.renderFormItem,
      plain = _ref2.plain,
      fieldProps = _ref2.fieldProps;

  var _ref3 = Array.isArray(text) ? text : [],
      _ref4 = _slicedToArray(_ref3, 2),
      startText = _ref4[0],
      endText = _ref4[1];

  var parsedStartText = startText ? moment(startText).format((fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.format) || format || 'YYYY-MM-DD') : '';
  var parsedEndText = endText ? moment(endText).format((fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.format) || format || 'YYYY-MM-DD') : '';

  if (mode === 'read') {
    var dom = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, parsedStartText || '-'), /*#__PURE__*/React.createElement("div", null, parsedEndText || '-'));

    if (render) {
      return render(text, _objectSpread({
        mode: mode
      }, fieldProps), /*#__PURE__*/React.createElement("span", null, dom));
    }

    return dom;
  }

  if (mode === 'edit' || mode === 'update') {
    var value = fieldProps.value;
    var momentValue = parseValueToMoment(value);

    var _dom2 = /*#__PURE__*/React.createElement(_TimePicker.RangePicker, _extends({
      format: format,
      bordered: plain === undefined ? true : !plain
    }, fieldProps, {
      value: momentValue
    }));

    if (renderFormItem) {
      return renderFormItem(text, _objectSpread({
        mode: mode
      }, fieldProps), _dom2);
    }

    return _dom2;
  }

  return null;
};

export { FieldTimeRangePicker };
export default /*#__PURE__*/React.forwardRef(FieldTimePicker);